module.exports = __webpack_public_path__ + "static/flor-c4c157a7a33d6c943089cf4667b9a238.svg";